import React from 'react'
import styled from 'styled-components/native'

import List from 'APP/Components/List'
import Card from 'APP/Converse/Card'
import Icon from 'APP/Converse/Icon'
import Typography from 'APP/Converse/Typography'
import { Images } from 'APP/Themes'
import { useTheme } from 'styled-components/native'

const ServiceCheckoutItemListItemContainer = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.metrics.baseMargin / 4}px;
`

const ServiceCheckoutItemHeadingContainer = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

const ServiceCheckoutItemCardContent = styled.View`
  gap: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

const ServiceCheckoutItemContainer = styled.View`
  gap: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

export interface ServiceCheckoutItemProps {
  serviceSlug: string
  serviceName: string
  serviceIconKey: keyof typeof Images.serviceGroups
  serviceIncludes: string[]
}

export const ServiceCheckoutItem = ({
  serviceSlug,
  serviceName,
  serviceIconKey,
  serviceIncludes,
}: ServiceCheckoutItemProps) => {
  const theme = useTheme()
  const ServiceIcon = Images.serviceGroups[serviceIconKey]
  return (
    <ServiceCheckoutItemContainer testID="SERVICE_CHECKOUT_ITEM" key={serviceSlug}>
      <Card testID="SERVICE_CHECKOUT_ITEM_CARD">
        <ServiceCheckoutItemCardContent>
          <ServiceCheckoutItemHeadingContainer>
            <ServiceIcon
              width={theme.metrics.icon.small}
              height={theme.metrics.icon.small}
              fillLine={theme.colors.serviceIconPrimary}
              accentFillLine={theme.colors.serviceIconAccent}
            />
            <Typography variant="bodyNormalBold">{serviceName}</Typography>
          </ServiceCheckoutItemHeadingContainer>
          <List>
            {serviceIncludes.map((included: string, index: number) => (
              <ServiceCheckoutItemListItemContainer key={index}>
                <Icon src="check" variant="material" />
                <Typography>{included}</Typography>
              </ServiceCheckoutItemListItemContainer>
            ))}
          </List>
        </ServiceCheckoutItemCardContent>
      </Card>
    </ServiceCheckoutItemContainer>
  )
}
